export const URLbackend = ""; // http://pmrmd.dextechnology.com:20502

export const countNews = 8;
